'use client';
import { ProductCardContext } from '.';
import { useTranslations } from 'next-intl';
import { useContext, useState } from 'react';
import { capitalize } from '@/shared/lib/capitalize';
import { useGetLocalizedValue } from '@/shared/lib/hooks/useGetLocalizedValue';
import { Select } from '@/shared/ui/select';
import { ProductCardProps } from './types';

type Props = Partial<Pick<ProductCardProps, 'variants' | 'defaultVariantId'>>;
export const ProductCardSelect = ({ variants, defaultVariantId }: Props) => {
    const t = useTranslations();
    const getLocalizedValue = useGetLocalizedValue();
    const [isOpen, setIsOpen] = useState(false);
    const context = useContext(ProductCardContext);
    const { selectedVariantId, setSelectedVariantId } = context;

    const finalVariants = variants ?? context.variants;
    const finalDefaultVariantId = defaultVariantId ?? context.defaultVariantId;

    if (!finalVariants || !finalVariants.length) {
        return null;
    }

    return (
        <Select
            open={isOpen}
            onOpenChange={setIsOpen}
            data-testid="product-card-select"
            value={selectedVariantId}
            defaultValue={finalDefaultVariantId}
            onValueChange={(value) => setSelectedVariantId(value)}
        >
            <Select.Trigger
                className="product-card__select-trigger"
                data-testid="product-card-variant-select"
                variant="rounded"
                data-state={isOpen ? 'open' : 'closed'}
            >
                <Select.Value placeholder={t('WORDS.SELECT_VARIANT')} />
            </Select.Trigger>
            <Select.Content data-testid="product-card-variant-select-content">
                {finalVariants.map(({ label, id }) => (
                    <Select.Item key={id} value={id} data-testid="product-card-variant-select-item">
                        {(label ? getLocalizedValue(label) : '') || capitalize(t('WORDS.DEFAULT'))}
                    </Select.Item>
                ))}
            </Select.Content>
        </Select>
    );
};
